enum Currency {
  Eth = 'eth',
  Honey = 'honey',
  Ape = 'ape',
}

export default Currency;
